import { render } from "./CardFooter.vue?vue&type=template&id=49a72017&scoped=true"
import script from "./CardFooter.vue?vue&type=script&lang=js"
export * from "./CardFooter.vue?vue&type=script&lang=js"

import "./CardFooter.vue?vue&type=style&index=0&id=49a72017&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a72017"]])

export default __exports__